/* Pioupiou V9 — performance (animations et vidéos hors écran) + fenêtre avant paiement en 3 étapes (V13) */
(function () {
  var hasIO = 'IntersectionObserver' in window;

  /* 1. Met en pause les animations des sections hors écran */
  function initAnimPause() {
    if (!hasIO) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.classList.toggle('anim-off', !e.isIntersecting); });
    }, { rootMargin: '150px 0px' });
    document.querySelectorAll('.shopify-section, main > section, main > div > section, body > section').forEach(function (s) { io.observe(s); });
  }

  /* 2. Vidéos d'ambiance : chargées et lancées à l'approche, relancées si le navigateur les a bloquées */
  function initLazyVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-p9-autoplay]'));
    if (!vids.length) return;
    var tryPlay = function (v) {
      if (document.hidden || v.dataset.p9In !== '1' || !v.paused) return;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    var start = function (v) {
      v.dataset.p9In = '1';
      if (v.dataset.poster) { v.setAttribute('poster', v.dataset.poster); v.removeAttribute('data-poster'); }
      if (!v.dataset.p9Ready) {
        v.dataset.p9Ready = '1'; /* V3 - WebM (plus leger) pour Chrome, Android, Firefox ; MP4 pour iPhone, iPad et Safari */ var ua = navigator.userAgent, webm = v.querySelector('source[type="video/webm"]'); if (webm && v.firstElementChild !== webm && !/iP(hone|ad|od)/.test(ua) && !(/AppleWebKit/.test(ua) && !/Chrome|Chromium|Android/.test(ua)) && v.canPlayType('video/webm; codecs="vp9"')) { v.insertBefore(webm, v.firstElementChild); v.load(); }
        v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('autoplay', '');
        v.preload = 'auto';
        v.addEventListener('loadedmetadata', function () { tryPlay(v); });
        v.addEventListener('canplay', function () { tryPlay(v); });
        v.addEventListener('play', function () { if (v.dataset.p9In !== '1') v.pause(); });
      }
      tryPlay(v);
    };
    var all = function () { vids.forEach(tryPlay); };
    if (!('IntersectionObserver' in window)) { vids.forEach(start); }
    else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) start(e.target);
          else { e.target.dataset.p9In = '0'; if (!e.target.paused) e.target.pause(); }
        });
      }, { rootMargin: '300px 0px' });
      vids.forEach(function (v) { io.observe(v); });
    }
    document.addEventListener('visibilitychange', all);
    window.addEventListener('pageshow', all);
    /* Mode économie d'énergie (iPhone) : la lecture auto est bloquée, on relance au premier toucher */
    document.addEventListener('touchend', all, { passive: true });
    document.addEventListener('click', all);
  }

  /* 3. V13 — Fenêtre avant paiement en 3 étapes :
        1. housses (offertes dans les packs, ou housse de rechange en option)
        2. couette assortie, seule
        3. paiement (bouton du thème)
        Nos tuiles pilotent les contrôles existants du thème (masqués) : la taille suit celle de l’oreiller. */
  function initUpsell() {
    var modal = document.querySelector('[data-direct-checkout-upsell]');
    if (!modal || modal.querySelector('[data-p13-flow]')) return;
    var content = modal.querySelector('.direct-upsell-content');
    if (!content) return;
    var sheet = modal.querySelector('.direct-checkout-upsell__sheet');
    var hide = function (node) { if (node) node.style.setProperty('display', 'none', 'important'); };
    var es = (document.documentElement.lang || '').toLowerCase().indexOf('es') === 0;
    var t = es ? {
      steps: ['Fundas', 'Edredón', 'Pago'], next: 'Continuar', back: '← Fundas', add: 'Añadir', added: 'Añadida', cover: 'Funda', free: 'De regalo', chosen: 'Elegida', choose: 'Elegir', giftN: 'Funda de regalo n.º ',
      giftEyebrow: 'Incluidas en tu pack', giftTitle1: 'Tu funda de regalo', giftTitleN: 'Tus fundas de regalo', giftCopy: 'Elige el diseño de cada una: serán de la medida de su almohada.',
      optEyebrow: 'Opcional', optTitle: '¿Una funda de repuesto?', optCopy: 'Práctica los días de lavado: su diseño favorito siempre listo.', note: 'De la medida de su almohada',
      cEyebrow: 'Para completar su nidito', cTitle: '¿Y su edredón a juego?', cCopy: 'Calentito, nunca demasiado. Cama infantil 120 × 150 cm.', cAdd: 'Añadir el edredón', cAdded: 'Edredón añadido', busy: 'Un momento…', error: 'No se pudo añadir. Inténtalo de nuevo.'
    } : {
      steps: ['Housses', 'Couette', 'Paiement'], next: 'Continuer', back: '← Housses', add: 'Ajouter', added: 'Ajoutée', cover: 'Housse', free: 'Offerte', chosen: 'Choisie', choose: 'Choisir', giftN: 'Housse offerte n°',
      giftEyebrow: 'Incluses dans votre pack', giftTitle1: 'Votre housse offerte', giftTitleN: 'Vos housses offertes', giftCopy: 'Choisissez le motif de chacune : elles seront à la taille de son oreiller.',
      optEyebrow: 'En option', optTitle: 'Une housse de rechange ?', optCopy: 'Pratique les soirs de lavage : son motif préféré reste au rendez-vous.', note: 'À la taille de son oreiller',
      cEyebrow: 'Pour finir son petit nid', cTitle: 'Et sa couette assortie ?', cCopy: 'Bien au chaud, jamais trop chaud. Format lit enfant 120 × 150 cm.', cAdd: 'Ajouter la couette', cAdded: 'Couette ajoutée', busy: 'Un instant…', error: 'L’ajout n’a pas abouti. Réessayez.'
    };
    if (!es) {
      var labels = modal.querySelector('[data-direct-upsell-labels]');
      if (!labels) { labels = document.createElement('script'); labels.type = 'application/json'; labels.setAttribute('data-direct-upsell-labels', ''); modal.appendChild(labels); }
      var current = {};
      try { current = JSON.parse(labels.textContent || '{}') || {}; } catch (e) { current = {}; }
      current.without = 'Continuer vers le paiement';
      current.checkout = 'Continuer vers le paiement';
      labels.textContent = JSON.stringify(current);
    }
    var data = {};
    try { data = JSON.parse((document.getElementById('P13UpsellData') || {}).textContent || '{}') || {}; } catch (e) { data = {}; }
    var couette = data.couette && data.couette.variants && data.couette.variants.length ? data.couette : null;
    var choices = Array.prototype.slice.call(modal.querySelectorAll('[data-direct-upsell-choice]'));
    var giftRows = Array.prototype.slice.call(modal.querySelectorAll('[data-direct-gift-row]'));
    var addBtn = modal.querySelector('[data-direct-upsell-add]');
    var lines = modal.querySelector('[data-direct-paid-lines]');
    var checkoutBtn = modal.querySelector('[data-direct-upsell-skip]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var text = function (node, value) { node.textContent = value; return node; };
    /* Les blocs d’origine du thème restent dans la page (leur logique sert toujours), mais sont masqués */
    hide(modal.querySelector('.direct-gifts-head'));
    hide(modal.querySelector('[data-direct-gift-list]'));
    hide(modal.querySelector('[data-direct-paid-extra]'));

    var flow = document.createElement('div');
    flow.className = 'p13-flow';
    flow.setAttribute('data-p13-flow', '');
    flow.innerHTML =
      '<ol class="p13-progress" aria-label="Étapes"></ol>' +
      '<section class="p13-step" data-p13-step-panel="1">' +
        '<header class="p13-head"><p class="p13-eyebrow"></p><h2 class="p13-title"></h2><p class="p13-copy"></p></header>' +
        '<div class="p13-gifts" data-p13-gifts></div>' +
        '<div class="p13-tiles" data-p13-tiles></div>' +
        '<p class="p13-note" data-p13-note></p>' +
        '<p class="p13-status" role="status" aria-live="polite"></p>' +
        '<button type="button" class="p13-next"></button>' + '<button type="button" class="p13-skip"></button>' +
      '</section>' +
      '<section class="p13-step" data-p13-step-panel="2" hidden>' +
        '<button type="button" class="p13-back"></button>' +
        '<header class="p13-head"><p class="p13-eyebrow"></p><h2 class="p13-title"></h2><p class="p13-copy"></p></header>' +
        '<div class="p13-gallery"><div class="p13-gallery__track" tabindex="0"></div><div class="p13-gallery__dots" aria-hidden="true"></div></div>' +
        '<div class="p13-chips" role="radiogroup"></div>' +
        '<button type="button" class="p13-add" aria-pressed="false"></button>' +
        '<p class="p13-status" role="status" aria-live="polite"></p>' +
      '</section>';
    content.insertBefore(flow, content.firstChild);
    var progress = flow.querySelector('.p13-progress');
    var s1 = flow.querySelector('[data-p13-step-panel="1"]');
    var s2 = flow.querySelector('[data-p13-step-panel="2"]');
    var giftsBox = s1.querySelector('[data-p13-gifts]');
    var tiles = s1.querySelector('[data-p13-tiles]');
    var note = s1.querySelector('[data-p13-note]');
    var status1 = s1.querySelector('.p13-status');
    var status2 = s2.querySelector('.p13-status');
    var nextBtn = s1.querySelector('.p13-next');

    var stepNames = couette ? t.steps : [t.steps[0], t.steps[2]];
    stepNames.forEach(function (name) { progress.appendChild(text(document.createElement('li'), name)); });
    text(nextBtn, t.next + ' →');

    var tile = function (imgSrc, name, side) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'p13-tile';
      el.innerHTML = '<span class="p13-tile__img"><img alt="" loading="lazy" decoding="async"></span><i class="p13-tile__badge" aria-hidden="true">✓</i><span class="p13-tile__name"></span><span class="p13-tile__price"></span><span class="p13-tile__cta"></span>';
      if (imgSrc) el.querySelector('img').src = imgSrc;
      text(el.querySelector('.p13-tile__name'), name);
      text(el.querySelector('.p13-tile__price'), side);
      return el;
    };
    var imgOf = function (button) { var i = button.querySelector('img'); return i ? (i.currentSrc || i.src) : ''; };

    /* Housses en option (pack 1 oreiller) : deux grandes tuiles identiques */
    var setTile = function (el, on) {
      el.classList.toggle('is-added', on);
      el.setAttribute('aria-pressed', String(on));
      text(el.querySelector('.p13-tile__cta'), on ? '✓ ' + t.added : t.add);
    };
    /* V17 — housses en plus : quantité réglable (1 à 6 par motif), toujours en option */
    var qtyPlusBtn = modal.querySelector('[data-direct-upsell-plus]');
    var qtyMinusBtn = modal.querySelector('[data-direct-upsell-minus]');
    var paidLineFor = function (title) {
      return Array.prototype.slice.call(lines ? lines.querySelectorAll('.direct-paid-line') : []).filter(function (l) {
        var bb = l.querySelector('b');
        return bb && bb.textContent.trim() === title;
      })[0];
    };
    var housses = choices.map(function (choice) {
      var title = choice.getAttribute('data-title') || '';
      var price = choice.querySelector('strong');
      var el = document.createElement('div');
      el.className = 'p13-tile p13-tile--qty';
      el.setAttribute('role', 'group');
      el.setAttribute('aria-label', t.cover + ' ' + title);
      el.innerHTML = '<span class="p13-tile__img"><img alt="" loading="lazy" decoding="async"></span><span class="p13-tile__name"></span><span class="p13-tile__price"></span>' +
        '<span class="p13-qty"><button type="button" class="p13-qty__add"></button><button type="button" class="p13-qty__btn" data-q="-1">−</button><span class="p13-qty__n" aria-live="polite">0</span><button type="button" class="p13-qty__btn" data-q="1">+</button></span>';
      var src = imgOf(choice);
      if (src) el.querySelector('img').src = src;
      text(el.querySelector('.p13-tile__name'), title);
      text(el.querySelector('.p13-tile__price'), price ? price.textContent.trim() : '');
      var addB = el.querySelector('.p13-qty__add');
      var minusB = el.querySelector('[data-q="-1"]');
      var plusB = el.querySelector('[data-q="1"]');
      var nOut = el.querySelector('.p13-qty__n');
      text(addB, t.add);
      addB.setAttribute('aria-label', t.add + ' : ' + t.cover + ' ' + title);
      minusB.setAttribute('aria-label', (es ? 'Quitar una funda ' : 'Retirer une housse ') + title);
      plusB.setAttribute('aria-label', (es ? 'Añadir una funda ' : 'Ajouter une housse ') + title);
      var q = 0, MAX = 6;
      var paint = function () {
        el.classList.toggle('is-added', q > 0);
        el.classList.toggle('has-qty', q > 0);
        nOut.textContent = String(q);
        plusB.disabled = q >= MAX;
      };
      var setQty = function (n) {
        if (modal.getAttribute('aria-busy') === 'true') return;
        n = Math.max(0, Math.min(MAX, n));
        if (n === q) return;
        status1.textContent = '';
        var line = paidLineFor(title);
        var rm = line && line.querySelector('[data-remove-paid]');
        if (rm) rm.click();
        if (n > 0) {
          choice.click();
          for (var g = 0; g < 10 && qtyMinusBtn && !qtyMinusBtn.disabled; g++) qtyMinusBtn.click();
          for (var k = 1; k < n; k++) { if (qtyPlusBtn && !qtyPlusBtn.disabled) qtyPlusBtn.click(); }
          if (addBtn && !addBtn.disabled) addBtn.click();
          if (!paidLineFor(title)) { status1.textContent = t.error; n = 0; }
        }
        q = n;
        paint();
      };
      addB.addEventListener('click', function () { setQty(1); });
      minusB.addEventListener('click', function () { setQty(q - 1); });
      plusB.addEventListener('click', function () { setQty(q + 1); });
      el.__reset = function () { q = 0; paint(); };
      paint();
      tiles.appendChild(el);
      return el;
    });
    /* « Voir plus » : housses en plus aussi pour les packs 2 et 3 oreillers, repliées par défaut */
    var moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.className = 'p13-more';
    moreBtn.hidden = true;
    var moreLabel = function (open) { return open ? (es ? '− Ocultar las fundas extra' : '− Masquer les housses en plus') : (es ? '+ ¿Fundas extra? Ver más' : '+ Des housses en plus ? Voir plus'); };
    giftsBox.parentNode.insertBefore(moreBtn, tiles);
    moreBtn.addEventListener('click', function () {
      var open = tiles.hidden;
      tiles.hidden = !open;
      note.hidden = !open;
      moreBtn.setAttribute('aria-expanded', String(open));
      text(moreBtn, moreLabel(open));
    });

    /* Housses offertes (packs) : une carte par housse, deux tuiles motif ; le choix est transmis au thème */
    var renderGifts = function (count) {
      giftsBox.innerHTML = '';
      giftRows.slice(0, count).forEach(function (row, index) {
        var card = document.createElement('div');
        card.className = 'p13-gift';
        card.innerHTML = '<p class="p13-gift__title"><b></b><span></span></p><div class="p13-gift__tiles" role="radiogroup"></div>';
        text(card.querySelector('b'), count > 1 ? t.giftN + (index + 1) : t.giftTitle1);
        text(card.querySelector('.p13-gift__title span'), t.free);
        var holder = card.querySelector('.p13-gift__tiles');
        var themeChoices = Array.prototype.slice.call(row.querySelectorAll('[data-direct-gift-choice]'));
        var mine = themeChoices.map(function (choice) {
          var el = tile(imgOf(choice), choice.getAttribute('data-title') || '', '');
          el.classList.add('p13-tile--gift');
          el.setAttribute('role', 'radio');
          el.addEventListener('click', function () {
            if (modal.getAttribute('aria-busy') === 'true') return;
            choice.click();
            paint();
          });
          holder.appendChild(el);
          return el;
        });
        var paint = function () {
          mine.forEach(function (el, i) {
            var on = themeChoices[i].getAttribute('aria-pressed') === 'true';
            el.classList.toggle('is-added', on);
            el.setAttribute('aria-checked', String(on));
            text(el.querySelector('.p13-tile__cta'), on ? '✓ ' + t.chosen : t.choose);
          });
        };
        paint();
        giftsBox.appendChild(card);
      });
    };

    /* Étape 2 : la couette, seule */
    var lineKey = null, cBusy = false, selected = 0, chips = [];
    var cAdd = s2.querySelector('.p13-add');
    var renderCouette = function () {
      if (!couette) return;
      chips.forEach(function (c, i) { c.setAttribute('aria-checked', String(i === selected)); c.disabled = !!lineKey || cBusy; });
      cAdd.classList.toggle('is-added', !!lineKey);
      cAdd.setAttribute('aria-pressed', String(!!lineKey));
      cAdd.disabled = cBusy || modal.getAttribute('aria-busy') === 'true';
      cAdd.textContent = cBusy ? t.busy : lineKey ? '✓ ' + t.cAdded : t.cAdd + ' · ' + couette.variants[selected].price;
    };
    if (couette) {
      text(s2.querySelector('.p13-back'), t.back);
      text(s2.querySelector('.p13-eyebrow'), t.cEyebrow);
      text(s2.querySelector('.p13-title'), t.cTitle);
      text(s2.querySelector('.p13-copy'), t.cCopy);
      /* V15 — galerie de la couette à faire défiler (swipe) */
      (function () {
        var gallery = s2.querySelector('.p13-gallery');
        var track = gallery.querySelector('.p13-gallery__track');
        var dotsBox = gallery.querySelector('.p13-gallery__dots');
        var pics = ((couette.gallery && couette.gallery.length) ? couette.gallery : [couette.image]).filter(Boolean);
        if (!pics.length) { gallery.hidden = true; return; }
        track.setAttribute('aria-label', es ? 'Fotos del edredón' : 'Photos de la couette');
        var slides = pics.map(function (src, i) {
          var slide = document.createElement('figure');
          slide.className = 'p13-gallery__slide';
          var img = document.createElement('img');
          img.alt = (es ? 'Edredón Pioupiou, foto ' : 'Couette Pioupiou, photo ') + (i + 1) + '/' + pics.length;
          img.decoding = 'async';
          img.loading = i ? 'lazy' : 'eager';
          img.src = typeof src === 'string' ? src : src.s; if (src && src.l) { img.srcset = src.s + ' 720w, ' + src.l + ' 1080w'; img.sizes = '(max-width: 560px) 86vw, 360px'; }
          slide.appendChild(img);
          track.appendChild(slide);
          return slide;
        });
        if (slides.length < 2) { gallery.classList.add('is-single'); return; }
        var dots = slides.map(function (slide) {
          var d = document.createElement('button');
          d.type = 'button';
          d.tabIndex = -1;
          d.addEventListener('click', function () {
            track.scrollTo({ left: slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2, behavior: 'smooth' });
          });
          dotsBox.appendChild(d);
          return d;
        });
        var current = -1;
        var mark = function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var best = 0, dist = Infinity;
          slides.forEach(function (s, i) {
            var dd = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
            if (dd < dist) { dist = dd; best = i; }
          });
          if (best === current) return;
          current = best;
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
        };
        var raf = 0;
        track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = 0; mark(); });
        }, { passive: true });
        new MutationObserver(function () {
          if (!s2.hidden) { slides.forEach(function (s) { var im = s.querySelector('img'); if (im && im.loading !== 'eager') im.loading = 'eager'; }); track.scrollLeft = 0; current = -1; mark(); }
        }).observe(s2, { attributes: true, attributeFilter: ['hidden'] });
        mark();
      })();
      var chipsBox = s2.querySelector('.p13-chips');
      chipsBox.setAttribute('aria-label', es ? 'Calidez del edredón' : 'Chaleur de la couette');
      selected = couette.variants.length > 2 ? 1 : 0;
      chips = couette.variants.map(function (v, i) {
        var m = /\(([^)]+)\)/.exec(v.title || '');
        var short = m ? m[1] : (v.title || '');
        var c = document.createElement('button');
        c.type = 'button';
        c.setAttribute('role', 'radio');
        c.innerHTML = '<span></span><b></b>';
        text(c.querySelector('span'), short.charAt(0).toUpperCase() + short.slice(1));
        text(c.querySelector('b'), v.price);
        c.addEventListener('click', function () { if (lineKey || cBusy) return; selected = i; renderCouette(); });
        chipsBox.appendChild(c);
        return c;
      });
      var post = function (url, body) {
        return fetch(root + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
      };
      cAdd.addEventListener('click', function () {
        if (cBusy || modal.getAttribute('aria-busy') === 'true') return;
        cBusy = true; status2.textContent = ''; renderCouette();
        var job = lineKey
          ? post('cart/change.js', { id: lineKey, quantity: 0 }).then(function () { lineKey = null; })
          : post('cart/add.js', { items: [{ id: Number(couette.variants[selected].id), quantity: 1, properties: { '_Pioupiou upsell': 'Couette' } }] })
              .then(function (res) { lineKey = res && res.items && res.items[0] ? res.items[0].key : null; });
        job.catch(function () { status2.textContent = t.error; })
          .then(function () { cBusy = false; renderCouette(); document.dispatchEvent(new CustomEvent('pioupiou:cart-updated')); });
      });
      /* V17 — couette : quantité réglable une fois ajoutée (plusieurs enfants) */
      var cQty = 0;
      var cBox = document.createElement('div');
      cBox.className = 'p13-cqty';
      cBox.hidden = true;
      cBox.innerHTML = '<button type="button" class="p13-qty__btn" data-cq="-1">−</button><span class="p13-cqty__label" aria-live="polite"></span><button type="button" class="p13-qty__btn" data-cq="1">+</button>';
      cAdd.parentNode.insertBefore(cBox, cAdd.nextSibling);
      var cMinus = cBox.querySelector('[data-cq="-1"]');
      var cPlus = cBox.querySelector('[data-cq="1"]');
      cMinus.setAttribute('aria-label', es ? 'Quitar un edredón' : 'Retirer une couette');
      cPlus.setAttribute('aria-label', es ? 'Añadir un edredón' : 'Ajouter une couette');
      var paintCQty = function () {
        if (!lineKey) cQty = 0; else if (!cQty) cQty = 1;
        cBox.hidden = !lineKey;
        cAdd.hidden = !!lineKey;
        var v = couette.variants[selected];
        var season = chips[selected] ? chips[selected].querySelector('span').textContent : '';
        text(cBox.querySelector('.p13-cqty__label'), '✓ ' + cQty + ' ' + (es ? (cQty > 1 ? 'edredones' : 'edredón') : (cQty > 1 ? 'couettes' : 'couette')) + (season ? ' ' + season : '') + ' · ' + (v ? v.price : '') + (cQty > 1 ? (es ? ' / ud.' : ' / pièce') : ''));
        cMinus.disabled = cBusy;
        cPlus.disabled = cBusy || cQty >= 6;
      };
      var baseRender = renderCouette;
      renderCouette = function () { baseRender(); paintCQty(); };
      var changeCQty = function (n) {
        if (!lineKey || cBusy || modal.getAttribute('aria-busy') === 'true') return;
        n = Math.max(0, Math.min(6, n));
        cBusy = true; status2.textContent = ''; renderCouette();
        post('cart/change.js', { id: lineKey, quantity: n })
          .then(function () { cQty = n; if (!n) lineKey = null; })
          .catch(function () { status2.textContent = t.error; })
          .then(function () { cBusy = false; renderCouette(); document.dispatchEvent(new CustomEvent('pioupiou:cart-updated')); });
      };
      cMinus.addEventListener('click', function () { changeCQty(cQty - 1); });
      cPlus.addEventListener('click', function () { changeCQty(cQty + 1); });
      s2.querySelector('.p13-back').addEventListener('click', function () { go(1); });
      renderCouette();
    }

    /* Navigation entre les étapes */
    var go = function (step) {
      modal.setAttribute('data-p13-step', String(step));
      s1.hidden = step !== 1;
      s2.hidden = step !== 2;
      Array.prototype.forEach.call(progress.children, function (li, i) {
        li.className = i + 1 < step ? 'is-done' : i + 1 === step ? 'is-current' : '';
      });
      content.scrollTop = 0;
      if (sheet) sheet.scrollTop = 0;
    };
    nextBtn.addEventListener('click', function () {
      if (modal.getAttribute('aria-busy') === 'true') return;
      if (couette) go(2); else if (checkoutBtn) checkoutBtn.click();
    });

    /* V15 — paiement direct depuis l’étape 1 : l’option reste discrète, le paiement d’abord */
    var skipBtn = s1.querySelector('.p13-skip');
    text(skipBtn, es ? 'Ir directamente al pago' : 'Passer directement au paiement');
    skipBtn.hidden = !couette || !checkoutBtn;
    skipBtn.addEventListener('click', function () {
      if (modal.getAttribute('aria-busy') === 'true') return;
      if (checkoutBtn) checkoutBtn.click();
    });
    /* V17 — le paiement en bouton principal ; la couette devient une option secondaire */
    if (couette && checkoutBtn) {
      flow.classList.add('p13-flow--pay-first');
      nextBtn.parentNode.insertBefore(skipBtn, nextBtn);
      text(skipBtn, es ? 'Ir directamente al pago →' : 'Passer directement au paiement →');
      text(nextBtn, es ? 'Ver el edredón a juego' : 'Voir la couette assortie');
    }

    /* À chaque ouverture : retour à l’étape 1, textes selon le pack, housses remises à zéro */
    var sync = function () {
      if (modal.hidden) return;
      var gifts = Number(modal.dataset.giftCount || 0);
      var head = s1.querySelector('.p13-head');
      text(head.querySelector('.p13-eyebrow'), gifts ? t.giftEyebrow : t.optEyebrow);
      text(head.querySelector('.p13-title'), gifts ? (gifts > 1 ? t.giftTitleN : t.giftTitle1) : t.optTitle);
      text(head.querySelector('.p13-copy'), gifts ? t.giftCopy : t.optCopy);
      flow.classList.toggle('p13-flow--gifts', gifts > 0);
      flow.setAttribute('data-gifts', String(gifts));
      tiles.hidden = gifts > 0; moreBtn.hidden = !gifts; moreBtn.setAttribute('aria-expanded', 'false'); text(moreBtn, moreLabel(false));
      giftsBox.hidden = gifts === 0;
      if (gifts) renderGifts(gifts); else giftsBox.innerHTML = '';
      var size = modal.querySelector('[data-direct-upsell-size][aria-pressed="true"]');
      note.hidden = gifts > 0;
      text(note, t.note + (size ? ' · ' + size.textContent.trim() : ''));
      housses.forEach(function (el) { if (el.__reset) el.__reset(); else setTile(el, false); });
      status1.textContent = '';
      status2.textContent = '';
      go(1);
    };
    var busySync = function () {
      var busy = modal.getAttribute('aria-busy') === 'true';
      flow.querySelectorAll('button').forEach(function (b) { b.disabled = busy; });
      if (!busy) renderCouette();
    };
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.attributeName === 'hidden') sync();
        if (r.attributeName === 'aria-busy') busySync();
      });
    }).observe(modal, { attributes: true, attributeFilter: ['hidden', 'aria-busy'] });
    sync();
  }

  function initAutoplayRescue() { /* V3 - iPhone : relance les videos auto visibles restees figees (mode economie d'energie, retour sur l'onglet) au premier toucher */ var kick = function () { if (document.hidden) return; Array.prototype.forEach.call(document.querySelectorAll('video[autoplay], video[data-p9-autoplay]'), function (v) { if (!v.paused || v.closest('[data-piou-video-carousel]') || v.dataset.p9In === '0') return; var r = v.getBoundingClientRect(); if (r.bottom <= 0 || r.top >= window.innerHeight || !r.width) return; v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }); }; ['touchstart', 'touchend', 'click', 'pageshow', 'load'].forEach(function (n) { window.addEventListener(n, kick, { passive: true }); }); document.addEventListener('visibilitychange', kick); } function init() { initAnimPause(); initLazyVideos(); initUpsell(); initAutoplayRescue(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
